import React from 'react';
import { Marker } from 'react-leaflet';
import { iconPOI } from '../MapComponents/mapIcons';
import { Place } from '../../models/Place';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { LeafletEvent } from 'leaflet';

type PlaceMarkerProps = {
	places: Place[];
	clickHandler: (place: Place) => {};
};

const PlaceMarkers: React.FC<PlaceMarkerProps> = ({ places, clickHandler }) => {
	const handleClusterClick = (e: LeafletEvent) => {
		console.log('Click : ', e);
		console.log('Markers : ', e.layer.getAllChildMarkers());
	};

	return (
		<>
			<MarkerClusterGroup onClick={handleClusterClick} chunkedLoading>
				{places.map((position, idx) => {
					return (
						<Marker
							key={`marker-${position.id}`}
							position={position.toLatLng()}
							icon={iconPOI}
							eventHandlers={{
								click: () => clickHandler(position),
							}}></Marker>
					);
				})}
			</MarkerClusterGroup>
		</>
	);
};

export default PlaceMarkers;
